import React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import Spacer from '../../uielements/Spacer'
import Wrapper from '../../components/Wrapper'
import InnerTitle from '../../uielements/InnerTitle'
import { graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'react-i18next'
import RegBlock from './regBlock'
import FlexWrapper from '../../uielements/flexWrapper'
import RichContent from '../../uielements/RichContent/richContent'
import { screenSizes } from '../../lib/constants'
import CurvyMore from '../../uielements/CurvyMore'

const RegWrapper = styled.div`
    display: block;
    height: 100vh;
    padding: 20px 15px;
    position: relative;
    background: ${theme.blue};

    @media (max-width: ${screenSizes.lg}px) {
        height: auto;
    }
`

const RegWrapperBg = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 40vh;
    background: ${theme.lightBlue};
`

const Registrations = () => {
    const { t, i18n } = useTranslation()

    const registrations = useStaticQuery(
        graphql`
            query FetchAllRegistrations {
                allContentfulRegistrations {
                    nodes {
                        title
                        slug
                        excerpt {
                            raw
                        }
                        node_locale
                        id
                        icon {
                            url
                            title
                            gatsbyImageData(quality: 75, jpegProgressive: true, sizes: "1920, 960, 480")
                        }
                    }
                }
            }
        `
    )

    const items = registrations.allContentfulRegistrations.nodes

    return (
        <>
            <RegWrapper>
                <RegWrapperBg />
                <Spacer top="6" />
                <Wrapper>
                    <InnerTitle title={t('titles.registrations_scholarships')} mainColor={theme.blue} secColor={theme.white} />
                </Wrapper>
                <Spacer top="8" />
                <Wrapper>
                    <FlexWrapper flexDirection="row" justifyContent="space-between">
                        {items.map(
                            (item) =>
                                item.node_locale === i18n.language && (
                                    <RegBlock key={item.id} title={item.title} slug={item.slug} icon={item.icon}>
                                        <RichContent body={item.excerpt} locale={i18n.language} />
                                    </RegBlock>
                                )
                        )}
                    </FlexWrapper>
                </Wrapper>
                <CurvyMore title={'#joinUs'} textColor={theme.lightBlue} />
            </RegWrapper>
        </>
    )
}

export default Registrations
